'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcQuickDelete
* @element ANY
* @description
* # tcQuickDelete
* Adds an 'X' link to input fields to quickly clear value on touch devices
*/
angular.module('tc.quickDelete', [])
.directive('tcQuickDelete', function($compile, GlobalService) {
	return {
		require: 'ngModel',
		link: function(parentScope, element, attrs, ctrl) {
			if (GlobalService.isTouchDevice()) {
				var scope = parentScope.$new(true);
				var templateString = '<div><md-icon md-svg-icon="system-close" ng-show="showQuickDelete()" ' +
					'ng-mousedown="clearField($event);" class="quickDeleteButton" tabindex="-1"></md-icon></div>';
				var template = $compile(templateString)(scope);
				element.after(template);	
			
				scope.clearField = function($event) {
					$event.preventDefault();
					ctrl.$setViewValue('');
					ctrl.$render();
				};
				
				var isEmpty = function() {
					return (element.val() === '');
				};
				
				var isDisabled = function() {
					return (element[0].getAttribute('readonly') || element[0].getAttribute('disabled'));	
				};
				
				scope.showQuickDelete = function() {
					return (scope.hasFocus && !isEmpty() && !isDisabled());	
				};
			
				element.bind('focus', function() {
					scope.hasFocus = true;
				});

				element.bind('input', function() {
					scope.$apply();	
				});
			
				element.bind('blur', function() {
					scope.hasFocus = false;
				});
			}
		}
	};
});
